const templateButtonType = {
  SHARE_LINK: 'share-link',
  URL: 'url',
  PHONE: 'phone',
  POSTBACK: 'postback',
  LOCATION: 'location',
};

export default templateButtonType;
